import { render, staticRenderFns } from "./JuniorHighSchoolEnglishCourse.vue?vue&type=template&id=40187b20&scoped=true&"
import script from "./JuniorHighSchoolEnglishCourse.vue?vue&type=script&lang=js&"
export * from "./JuniorHighSchoolEnglishCourse.vue?vue&type=script&lang=js&"
import style0 from "./JuniorHighSchoolEnglishCourse.vue?vue&type=style&index=0&id=40187b20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40187b20",
  null
  
)

export default component.exports